import React from "react";
import { useNavigate } from "react-router-dom";
import { Path } from "../../RoutesUtils";

const Prescription = ({ prescriptions }) => {
  const navigate = useNavigate();
  const setStatus = () => {
    if (prescriptions && prescriptions.length > 0) {
      navigate(Path.editPrescription, {
        state: {
          presc_name: prescriptions[0].presc_name,
          presc_quan: prescriptions[0].presc_quan,
          presc_stock_rem_date: prescriptions[0].presc_stock_rem_date,
          presc_comments: prescriptions[0].presc_comments,
          presc_id: prescriptions[0].presc_id,
        },
      });
    }
  };
  return (
    <>
      <h2 className="text-lg font-semibold bg-theme text-center text-white py-2 px-4 rounded-2xl mt-10 mb-4">
      Recept
      </h2>
      {prescriptions && prescriptions.length > 0 ? (
        prescriptions.map((val) => (
          <div className="bg-green text-white p-4 rounded-xl items-start">
            <div className="flex flex-col justify-between">
              <div>
                <h3 className="font-semibold mb-1">{val.presc_name}</h3>
                <p className="opacity-80">
                  Quantity Left:{" "}
                  <span className="text-[#F02B2B] font-bold">
                    {val.presc_quan}
                  </span>
                </p>
              </div>
              <button
                type="button"
                onClick={setStatus}
                className="px-8 py-1.5 text-sm bg-white text-green rounded-full mt-4"
              >
                Opdater status
              </button>
            </div>
          </div>
        ))
      ) : (
        <></>
      )}
    </>
  );
};

export default Prescription;
